(() => {
  function mount(root) {
    if (root.dataset.mounted) return;
    root.dataset.mounted = 'true';
    const catalog = JSON.parse(root.querySelector('[data-catalog]').textContent);
    const messages = JSON.parse(root.querySelector('[data-translations]').textContent);
    const form = root.querySelector('[data-form]');
    const sizes = root.querySelector('[data-sizes]');
    const money = new Intl.NumberFormat(root.dataset.locale || 'ro-RO', { style: 'currency', currency: root.dataset.currency || 'RON' });
    let mode = 'home';
    const configurator = root.querySelector('[data-configurator]');
    const packages = root.querySelector('[data-packages]');
    const months = () => mode === 'gift' ? Number(form.elements.gift_duration?.value || 3) : mode === 'prepaid3' ? 3 : mode === 'prepaid6' ? 6 : 1;
    const interpolate = (message, values) => Object.entries(values).reduce((text, [key, value]) => text.replaceAll('{' + key + '}', String(value)), message);
    const formatWeight = grams => grams < 1000 ? grams + ' g' : grams / 1000 + ' kg';
    let flexibleFrequency = form.elements.frequency.value;
    const sizeOf = variant => {
      const title = (variant.options?.[0] || variant.title.split('/')[0]).trim().toLowerCase().replace(/\s/g, '');
      if (title === '1kg' || title === '1000g') return 1000;
      if (title === '500g') return 500;
      if (title === '250g') return 250;
      return 0;
    };
    function selectedCoffee() { return catalog.find(p => String(p.id) === form.elements.coffee.value); }
    function findVariant(coffee, grams) { return coffee?.variants.find(v => sizeOf(v) === (mode === 'office' ? 1000 : grams) && v.available); }
    function makeSizes() {
      sizes.replaceChildren();
      const grams = mode === 'office' ? [1000, 2000, 3000, 4000, 5000] : [250, 500, 1000];
      grams.forEach((weight, index) => {
        const label = document.createElement('label');
        label.className = 'ecce-sub__choice';
        const input = document.createElement('input');
        input.type = 'radio'; input.name = 'weight'; input.value = String(weight); input.checked = index === 0;
        const span = document.createElement('span'); span.textContent = weight < 1000 ? `${weight} g` : `${weight / 1000} kg`;
        label.append(input, span); sizes.append(label);
      });
    }
    const mixOptions = root.querySelector('[data-mix-options]');
    const mixFields = root.querySelector('[data-mix-coffees]');
    const mixSlots = root.querySelector('[data-mix-slots]');
    const quarterVariant = coffee => coffee?.variants.find(variant => sizeOf(variant) === 250 && variant.available);
    const mixCatalog = catalog.filter(coffee => quarterVariant(coffee));
    const canMix = grams => Boolean(mixOptions && mixFields && mixSlots && [500,1000].includes(grams) && mixCatalog.length);
    function renderMixSlots(count, coffee) {
      if (mixSlots.children.length === count) return;
      const previous = [...mixSlots.querySelectorAll('select')].map(select => select.value);
      mixSlots.replaceChildren();
      for (let index = 0; index < count; index++) {
        const label = document.createElement('label');
        const text = document.createElement('span');
        text.textContent = interpolate(messages.mixBag,{index:index + 1});
        const select = document.createElement('select');
        select.name = 'mix_origin_' + index;
        select.required = true;
        for (const entry of mixCatalog) {
          const option = document.createElement('option');
          option.value = String(entry.id);
          option.textContent = entry.title + ' · ' + money.format(Math.round(quarterVariant(entry).price * .9) / 100);
          select.append(option);
        }
        const currentCoffee = mixCatalog.some(entry => entry.id === coffee?.id) ? coffee : mixCatalog[0];
        const defaultIndex = (mixCatalog.indexOf(currentCoffee) + index) % mixCatalog.length;
        select.value = mixCatalog.some(entry => String(entry.id) === previous[index]) ? previous[index] : String(mixCatalog[defaultIndex].id);
        label.append(text,select);
        mixSlots.append(label);
      }
    }
    function update() {
      let coffee = selectedCoffee();
      const coffeeInputs = [...form.querySelectorAll('input[name="coffee"]')];
      for (const input of coffeeInputs) {
        const entry = catalog.find(p => String(p.id) === input.value);
        input.disabled = !entry?.variants.some(v => v.available && (mode !== 'office' || sizeOf(v) === 1000));
      }
      if (!coffee || form.querySelector('input[name="coffee"]:checked')?.disabled) {
        const eligible = coffeeInputs.find(input => !input.disabled);
        if (eligible) { eligible.checked = true; coffee = selectedCoffee(); }
        else coffee = null;
      }
      const weightInputs = [...sizes.querySelectorAll('input')];
      for (const input of weightInputs) input.disabled = !findVariant(coffee, Number(input.value)) && !canMix(Number(input.value));
      let checked = sizes.querySelector('input:checked');
      if (!checked || checked.disabled) {
        checked = weightInputs.find(input => !input.disabled);
        if (checked) checked.checked = true;
      }
      const grams = Number(checked?.value || 0);
      const variant = findVariant(coffee, grams);
      const mixAvailable = canMix(grams);
      const singleInput = form.querySelector('input[name="selection_type"][value="single"]');
      const mixInput = form.querySelector('input[name="selection_type"][value="mix"]');
      const forcedMix = mixAvailable && !variant && !mixInput?.checked;
      if (singleInput && mixInput) {
        singleInput.disabled = mixAvailable && !catalog.some(entry => findVariant(entry,grams));
        if (!mixAvailable) singleInput.checked = true;
        else if (!variant) mixInput.checked = true;
      }
      const mixed = mixAvailable && Boolean(mixInput?.checked);
      if (mixOptions) { mixOptions.hidden = !mixAvailable; mixOptions.disabled = !mixAvailable; }
      if (mixFields) { mixFields.hidden = !mixed; mixFields.disabled = !mixed; }
      const singleFields = root.querySelector('[data-single-coffee]');
      if (singleFields) { singleFields.hidden = mixed; singleFields.disabled = mixed; }
      let mixture = [];
      if (mixed) {
        const count = grams / 250;
        renderMixSlots(count,coffee);
        if (forcedMix && quarterVariant(coffee)) mixSlots.querySelector('select').value = String(coffee.id);
        mixture = [...mixSlots.querySelectorAll('select')].map(select => mixCatalog.find(entry => String(entry.id) === select.value));
        root.querySelector('[data-mix-hint]').textContent = interpolate(messages.mixHint,{count});
      }
      const selectionAvailable = mixed ? mixture.length === grams / 250 && mixture.every(entry => quarterVariant(entry)) : Boolean(variant);
      const quantity = Math.max(1, Math.min(50, Math.trunc(Number(form.elements.quantity.value) || 1)));
      const quantityLabel = root.querySelector('[data-quantity-label]');
      if (quantityLabel) quantityLabel.textContent = mixed ? messages.mixQuantity : messages.singleQuantity;
      const units = mode === 'office' ? grams / 1000 : 1;
      const prepaid = months() > 1;
      const gift = mode === 'gift';
      for (const selector of ['[data-gift-duration]','[data-gift-details]']) {
        const fields = root.querySelector(selector);
        if (fields) { fields.hidden = !gift; fields.disabled = !gift; }
      }
      const originalCoffee = !selectionAvailable ? 0 : mixed ? mixture.reduce((sum,entry) => sum + quarterVariant(entry).price,0) * quantity : variant.price * units * quantity;
      const discountedCoffee = Math.round(originalCoffee * .9);
      const shipping = grams * quantity >= 1000 ? 0 : 1000;
      const total = prepaid ? (discountedCoffee + shipping) * months() : discountedCoffee;
      const original = prepaid ? (originalCoffee + shipping) * months() : originalCoffee;
      const delivery = root.querySelector('[data-delivery]');
      if (delivery) delivery.textContent = !selectionAvailable ? messages.unavailable : prepaid ? interpolate(shipping === 0 ? messages.prepaidDeliveryFree : messages.prepaidDeliveryPaid, {months:months(), shipping:money.format(shipping * months() / 100)}) : shipping === 0 ? messages.deliveryFree : messages.deliveryPaid;
      root.querySelector('[data-price]').textContent = selectionAvailable ? money.format(total / 100) : messages.unavailable;
      root.querySelector('[data-original]').textContent = selectionAvailable ? money.format(original / 100) : '';
      root.querySelector('[data-price-unit]').textContent = prepaid ? messages.prepaidPriceUnit : messages.perDelivery;
      root.querySelector('[data-purchase-heading]').textContent = gift ? messages.giftPurchaseHeading : prepaid ? messages.prepaidHeading : messages.purchaseHeading;
      root.querySelector('[data-prepaid-note]').hidden = !prepaid;
      root.querySelector('[data-prepaid-note]').textContent = prepaid ? interpolate(gift ? messages.giftNote : messages.prepaidNote, {months:months()}) : '';
      root.querySelector('[data-consent]').textContent = prepaid ? interpolate(gift ? messages.giftConsent : messages.prepaidConsent,{months:months()}) : messages.consent;
      root.querySelector('[data-cta]').textContent = gift ? messages.giftCta : prepaid ? messages.prepaidCta : messages.cta;
      root.querySelector('[data-flexibility]').textContent = gift ? messages.giftFlexibility : prepaid ? messages.prepaidFlexible : messages.flexible;
      const grind = form.querySelector('input[name="grind"]:checked')?.nextElementSibling?.textContent || messages.beans;
      const quantitySummary = interpolate(messages.summaryQuantity, {quantity, weight:formatWeight(grams)});
      const deliverySummary = prepaid ? interpolate(messages.monthlySummary, {months:months()}) : form.elements.frequency.value + ' ' + messages.days;
      let contents = coffee?.title || '';
      if (mixed) {
        const grouped = new Map();
        for (const entry of mixture) grouped.set(entry.id,{coffee:entry.title,count:(grouped.get(entry.id)?.count || 0) + 1});
        contents = [...grouped.values()].map(entry => interpolate(messages.mixItem,entry)).join(' + ');
      }
      root.querySelector('[data-summary]').textContent = selectionAvailable ? contents + ' · ' + quantitySummary + ' · ' + interpolate(messages.totalPerDelivery,{weight:formatWeight(grams * quantity)}) + ' · ' + grind + ' · ' + deliverySummary + (mode === 'office' && !mixed ? ' · ' + messages.officeNote : '') : messages.unavailable;
      if (gift) {
        const recipient = [form.elements.gift_first_name?.value.trim(),form.elements.gift_last_name?.value.trim()].filter(Boolean).join(' ');
        if (recipient && selectionAvailable) root.querySelector('[data-summary]').textContent += ' · ' + interpolate(messages.giftRecipientSummary,{recipient});
      }
      const imageCoffee = mixed ? mixture[0] : coffee;
      const image = root.querySelector('.ecce-sub__image');
      if (imageCoffee?.image && image && image.dataset.coffee !== String(imageCoffee.id)) {
        image.removeAttribute('srcset'); image.src = imageCoffee.image; image.alt = imageCoffee.title; image.dataset.coffee = String(imageCoffee.id);
      }
    }
    function choosePackage(nextMode, reveal = false) {
      if (months() === 1) flexibleFrequency = form.elements.frequency.value;
      mode = nextMode;
      const singleOrigin = form.querySelector('input[name="selection_type"][value="single"]');
      if (singleOrigin) singleOrigin.checked = true;
      root.querySelectorAll('[data-mode]').forEach(item => item.setAttribute('aria-pressed', String(item.dataset.mode === mode)));
      root.querySelector('[data-title]').textContent = mode === 'gift' ? messages.giftTitle : mode === 'office' ? messages.officeTitle : mode === 'prepaid3' ? messages.prepaid3Title : mode === 'prepaid6' ? messages.prepaid6Title : messages.homeTitle;
      root.querySelector('[data-frequency]').hidden = months() > 1;
      form.elements.frequency.disabled = months() > 1;
      form.elements.frequency.value = months() > 1 ? '30' : flexibleFrequency;
      form.elements.consent.checked = false;
      makeSizes(); update();
      if (reveal && configurator) {
        configurator.hidden = false;
        packages.hidden = true;
        const title = root.querySelector('[data-title]');
        title.focus({preventScroll:true});
        configurator.scrollIntoView({block:'start'});
      }
    }
    root.querySelectorAll('[data-mode]').forEach(button => button.addEventListener('click', () => choosePackage(button.dataset.mode)));
    root.querySelectorAll('[data-package]').forEach(button => button.addEventListener('click', () => choosePackage(button.dataset.package, true)));
    root.querySelector('[data-back]')?.addEventListener('click', () => {
      configurator.hidden = true;
      packages.hidden = false;
      root.querySelector('[data-packages-heading]').focus({preventScroll:true});
      packages.scrollIntoView({block:'start'});
    });
    root.querySelectorAll('[data-package-price]').forEach(node => {
      const kind = node.dataset.packagePrice;
      const term = kind === 'gift' || kind === 'prepaid3' ? 3 : kind === 'prepaid6' ? 6 : 1;
      const prices = catalog.flatMap(coffee => coffee.variants.filter(variant => variant.available && (kind === 'office' ? sizeOf(variant) === 1000 : [250,500,1000].includes(sizeOf(variant)))).map(variant => (Math.round(variant.price * .9) + (term > 1 && sizeOf(variant) < 1000 ? 1000 : 0)) * term));
      node.textContent = prices.length ? money.format(Math.min(...prices) / 100) : messages.unavailable;
    });
    if (configurator && packages) configurator.hidden = true;
    const tabs = [...root.querySelectorAll('[data-tab]')];
    function selectTab(tab, focus = false) {
      tabs.forEach(item => { const selected = item === tab; item.setAttribute('aria-selected', String(selected)); item.tabIndex = selected ? 0 : -1; });
      root.querySelectorAll('[data-panel]').forEach(panel => { panel.hidden = panel.dataset.panel !== tab.dataset.tab; });
      if (focus) tab.focus();
    }
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => selectTab(tab));
      tab.addEventListener('keydown', event => {
        let target;
        if (event.key === 'ArrowRight') target = tabs[(index + 1) % tabs.length];
        if (event.key === 'ArrowLeft') target = tabs[(index + tabs.length - 1) % tabs.length];
        if (event.key === 'Home') target = tabs[0];
        if (event.key === 'End') target = tabs[tabs.length - 1];
        if (target) { event.preventDefault(); selectTab(target, true); }
      });
    });
    const giftDate = form.elements.gift_start_date;
    if (giftDate) giftDate.min = new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Bucharest',year:'numeric',month:'2-digit',day:'2-digit'}).format(new Date());
    form.addEventListener('change', event => {
      if (event.target.name === 'selection_type' && event.target.value === 'single') {
        const grams = Number(sizes.querySelector('input:checked')?.value || 0);
        if (!findVariant(selectedCoffee(),grams)) {
          const replacement = catalog.find(entry => findVariant(entry,grams));
          const input = replacement && form.querySelector('input[name="coffee"][value="' + replacement.id + '"]');
          if (input) input.checked = true;
        }
      }
      if (event.target !== form.elements.consent) form.elements.consent.checked = false;
      update();
    });
    for (const field of ['gift_first_name','gift_last_name']) form.elements[field]?.addEventListener('input',update);
    form.elements.quantity.addEventListener('input', update);
    form.elements.quantity.addEventListener('blur', () => { form.elements.quantity.value = String(Math.max(1, Math.min(50, Math.trunc(Number(form.elements.quantity.value) || 1)))); update(); });
    form.addEventListener('submit', event => event.preventDefault());
    makeSizes(); update();
  }
  document.querySelectorAll('[data-ecce-subscription]').forEach(mount);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ecce-subscription]').forEach(mount));
})();




